<template>
  <div class="alert alert-primary d-flex align-items-center mt-4" role="alert">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data: function() {
    return {

    }
  },
  methods: {

  }
}
</script>
